import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { Notification } from '@/types'

interface NotificationsState {
  notifications: Notification[]
}

const initialState: NotificationsState = {
  notifications: [],
}

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Omit<Notification, 'id' | 'timestamp'>>) => {
      const notification: Notification = {
        id: Date.now(),
        timestamp: new Date().toISOString(),
        ...action.payload,
      }
      state.notifications.push(notification)
    },
    removeNotification: (state, action: PayloadAction<number>) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      )
    },
    clearNotifications: (state) => {
      state.notifications = []
    },
  },
})

export const { addNotification, removeNotification, clearNotifications } = notificationsSlice.actions

// Helper action creators
export const showSuccess = (message: string, title?: string) =>
  addNotification({ type: 'success', message, title })

export const showError = (message: string, title?: string) =>
  addNotification({ type: 'error', message, title })

export const showWarning = (message: string, title?: string) =>
  addNotification({ type: 'warning', message, title })

export const showInfo = (message: string, title?: string) =>
  addNotification({ type: 'info', message, title })

export default notificationsSlice.reducer
